import { useEffect, useState } from 'react'

import { fechaIsoToFullWithT } from '../utils/utils'

/* Reusable Input Field Component
 */
const InputField: React.FC<{
  // label: string; name: string; value?: string | number | Date; type: string; className?: string
  label: string
  name: string
  value?: string | number
  type: string
  className?: string
  placeholder?: string
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
  errors?: { [key: string]: string }
  inputClassName?: string
  handleKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  disabled?: boolean
}> = ({
  placeholder,
  label,
  name,
  value,
  type,
  className,
  handleInputChange,
  errors,
  inputClassName,
  handleKeyDown,
  onBlur,
  disabled,
}) => {
  let formattedValue: string | number = ''
  const myClassName = className ?? 'flex flex-col'
  const [inputClass, setInputClass] = useState<string>('')

  formattedValue = value ?? ''

  if (type === 'datetime-local' && typeof formattedValue === 'string') {
    formattedValue = fechaIsoToFullWithT(formattedValue)
  }
  const inputClassDef = inputClassName ?? 'border rounded p-2'

  // Si el user escribe algo, borramos el borde rojo
  const handleInputChangeInt = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    const hayError = errors && errors[name]

    if (hayError && value !== '') {
      setInputClass(inputClassDef)
    }
    handleInputChange(e)
  }

  useEffect(() => {
    const hayError = errors && errors[name]
    const borderColor = hayError ? 'ring-4 ring-red-500' : ''
    setInputClass(`${inputClassDef} ${borderColor}`)
  }, [errors, name])

  return (
    <div className={myClassName}>
      <label className="font-semibold mb-1">{label}</label>

      <input
        placeholder={placeholder}
        className={inputClass}
        name={name}
        type={type}
        value={formattedValue}
        onChange={handleInputChangeInt}
        onKeyDown={handleKeyDown}
        onBlur={onBlur}
        disabled={disabled}
      />
    </div>
  )
  /* ALGO RARO PASA CON LAS FECHAS. SE ACHICAN con el "relative"
  return (
    <div className={myClassName}>
      <label className="font-semibold mb-1">{label}</label>
      <div className="relative"> 
        <input className={inputClass} name={name} type={type} value={formattedValue} onChange={handleInputChange} />
       
        {hayError && (
          <div className="absolute z-10 bottom--1 right-0 transform translate-x-5 -translate-y-10 text-red-500 text-4xl">
            *
          </div>
        )}
      </div>
    </div>
  );
  */
}
export default InputField
